export default __webpack_public_path__ + "static/media/AceiteAjonjoli.0204730d.jpeg";